<div class="box-avulso">
  <div
    class="soon-cover"
    *ngIf="comingsoon"
    [ngStyle]="{ 'background-image': 'url(' + cover + ')' }"
  ></div>

  <div class="ribbon" *ngIf="isNew && !comingsoon">
    <img src="https://unhide-static-prod.nyc3.cdn.digitaloceanspaces.com/ico-ribbon-novo.png" alt="Projeto novo" />
  </div>

  <a
    href=""
    class="link-container"
    [ngClass]="progress ? 'show-progress' : 'show-hover'"
  >
    <div class="link-header">
      <div class="header-bg" [style.background-image]="'url(' + cover + ')'">
        <h3 class="box-title">{{ title }}</h3>
      </div>

      <div class="watch-now" *ngIf="!comingsoon">
        <div class="label-watch-now-project icon-only">
          <img src="https://unhide-static-prod.nyc3.cdn.digitaloceanspaces.com/icon-watch-now-2020.png" [alt]="title" />

          <div class="text">Assistir aula</div>
        </div>
      </div>

      <div class="progress-container">
        <h4>Seu progresso:</h4>

        <unh-spinner-progress
          [value]="videoprogress"
          [diameter]="90"
        ></unh-spinner-progress>

        <h3>{{ title }}</h3>
      </div>
    </div>

    <div class="link-body">
      <ul class="features-list">
        <li>
          <img src="https://unhide-static-prod.nyc3.cdn.digitaloceanspaces.com/mosaico/icon-level.png" alt="" />
          <!-- <mat-icon svgIcon="unh_mosaico_level"></mat-icon> -->
          <span>Nível: Intermediário</span>
        </li>
        <li>
          <img src="https://unhide-static-prod.nyc3.cdn.digitaloceanspaces.com/mosaico/icon-clock.png" alt="" />
          <!-- <mat-icon svgIcon="unh_mosaico_clock"></mat-icon> -->
          <span>Duração: 11h23</span>
        </li>
        <li>
          <img src="https://unhide-static-prod.nyc3.cdn.digitaloceanspaces.com/mosaico/icon-sound.png" alt="" />
          <!-- <mat-icon svgIcon="unh_mosaico_sound"></mat-icon> -->
          <span>Áudio: Português</span>
        </li>
        <li>
          <img src="https://unhide-static-prod.nyc3.cdn.digitaloceanspaces.com/mosaico/icon-legends.png" alt="" />
          <!-- <mat-icon svgIcon="unh_mosaico_legends"></mat-icon> -->
          <span>Legenda: Inglês / Espanhol</span>
        </li>
        <li>
          <img src="https://unhide-static-prod.nyc3.cdn.digitaloceanspaces.com/mosaico/icon-teacher.png" alt="" />
          <!-- <mat-icon svgIcon="unh_mosaico_teacher"></mat-icon> -->
          <span>Por {{ instructorname }}</span>
        </li>
        <li>
          <img src="https://unhide-static-prod.nyc3.cdn.digitaloceanspaces.com/mosaico/icon-software.png" alt="" />
          <!-- <mat-icon svgIcon="unh_mosaico_software"></mat-icon> -->
          <span>Software:</span>
        </li>
      </ul>
    </div>
  </a>

  <div class="box-footer">
    <div class="container-price" *ngIf="!owned && !hiddenprice && !proonly">
      <h3 class="footer-title">Compre este curso por R$ 61,98</h3>
      <p class="footer-subtitle">ou assine o PRO por R$44/mês.</p>
    </div>

    <div *ngIf="owned && !hiddenprice && !proonly">
      <h3 class="footer-title-own">
        <mat-icon svgIcon="unh_check_blue"></mat-icon>
        Você comprou este curso
      </h3>
      <p class="footer-subtitle-own">Assista agora!</p>
    </div>

    <div *ngIf="proonly && !hiddenprice">
      <h3 class="footer-title-pro">
        <mat-icon svgIcon="unh_pro"></mat-icon>
        Disponível para Artistas PRO
      </h3>
      <p class="footer-subtitle-own">ou assine o PRO por R$44/mês.</p>
    </div>

    <div class="price-hidden" *ngIf="hiddenprice"></div>
  </div>
</div>
